import { render, staticRenderFns } from "./ProfileForm.vue?vue&type=template&id=9e88b864&scoped=true"
import script from "./ProfileForm.vue?vue&type=script&lang=js"
export * from "./ProfileForm.vue?vue&type=script&lang=js"
import style0 from "./ProfileForm.vue?vue&type=style&index=0&id=9e88b864&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e88b864",
  null
  
)

export default component.exports